import { KYMW4701Model } from '../kymw4701.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

export type GetMultiGoodsResponse = {
  MultiGoodsList: {
    MultiCode: string;
    CommonCatchcopy: string;
    CommonGoodsExplanation: string;
    PublishSeq: string;
    PCode: string;
    ApplyTermEnd: string;
    GuideGoodsName: string;
    GuideStandardName: string;
    MakerName: string;
    PayeeClient: string;
    RegistDate: string;
  }[];
};

/**
 * マルチ商品情報取得
 *
 * @export API通信成功時の処理
 * @class GetMultiGoodsService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetMultiGoodsService extends PlessJsonResponderSub<GetMultiGoodsResponse> {
  // 処理に使用するModel
  private model: KYMW4701Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMultiGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MultiCode: this.model.paramMultiCode,
        PCode: this.model.paramPcode,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4701Model} model
   * @param {GetMultiGoodsModel} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetMultiGoodsService
   */
  execute(model: KYMW4701Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getMultiGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMultiGoodsService
   */
  success(data: GetMultiGoodsResponse) {
    if (data) this.model.setMultiGoodsData(data);
    if (this.successFunc) this.successFunc();
  }
}
